import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'react-toolbox/lib/checkbox'
import withAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { PROJECT_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'

const RoleCheckbox = withAnyRoles(Checkbox)

const InternalCheckbox = (props) => {
  return (
    <RoleCheckbox
      roles={[
        ...Object.values(PROJECT_ROLES),
        ...Object.values(PRODUCT_ROLES)
      ]}
      {...props}
    />
  )
}

export default InternalCheckbox
